/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_FeatureSetResponseDto } from '../models/PagedResultDto_FeatureSetResponseDto';
import type { Wealthlane_AppServices_Features_FeatureSetDto } from '../models/Wealthlane_AppServices_Features_FeatureSetDto';
import type { Wealthlane_AppServices_Features_FeatureSetFeatureDto } from '../models/Wealthlane_AppServices_Features_FeatureSetFeatureDto';
import type { Wealthlane_AppServices_Features_FeatureSetResponseDto } from '../models/Wealthlane_AppServices_Features_FeatureSetResponseDto';
import type { Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class FeatureSetService {

    /**
     * @returns Wealthlane_AppServices_Features_FeatureSetDto OK
     * @throws ApiError
     */
    public static getApiIdentityFeatureSetOptions(): CancelablePromise<Array<Wealthlane_AppServices_Features_FeatureSetDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/feature-set/options',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_FeatureSetResponseDto OK
     * @throws ApiError
     */
    public static getApiIdentityFeatureSet(
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_FeatureSetResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/feature-set',
            query: {
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse OK
     * @throws ApiError
     */
    public static postApiIdentityFeatureSet(
requestBody?: Wealthlane_AppServices_Features_FeatureSetFeatureDto,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/identity/feature-set',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_AppServices_Features_FeatureSetResponseDto OK
     * @throws ApiError
     */
    public static getApiIdentityFeatureSet1(
id: string,
): CancelablePromise<Wealthlane_AppServices_Features_FeatureSetResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/feature-set/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @param requestBody 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse OK
     * @throws ApiError
     */
    public static putApiIdentityFeatureSet(
id: string,
requestBody?: Wealthlane_AppServices_Features_FeatureSetFeatureDto,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/identity/feature-set/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse OK
     * @throws ApiError
     */
    public static deleteApiIdentityFeatureSet(
id: string,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/identity/feature-set/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
